var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "card w-50 mx-auto p-5 d-flex align-items-center rounded shadow",
        attrs: { id: "main-card" }
      },
      [
        _c("div", { staticClass: "container h-100" }, [
          _c("div", { staticClass: "row justify-content-md-center" }, [
            _c("div", { staticClass: "col-12 mx-auto" }, [
              _vm.agencyLogo
                ? _c("img", {
                    attrs: {
                      src: require("./../assets/clients/" +
                        _vm.agencyLogo +
                        ".svg"),
                      id: "qrp-logo",
                      alt: "Rating Platform Logo",
                      width: "150px",
                      height: "auto"
                    }
                  })
                : _c("img", {
                    attrs: {
                      id: "qrp-logo",
                      src: require("./../assets/qrp-rtm-color.svg"),
                      alt: "QuinStreet Rating Platform",
                      width: "150px",
                      height: "auto"
                    }
                  })
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mx-auto w-100",
            attrs: { id: "card-inner-container" }
          },
          [
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "form",
                  { staticClass: "my-3", attrs: { autocomplete: "off" } },
                  [
                    _c("div", { staticClass: "row form-group" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-lg-10 col-xl-7 mx-auto" },
                        [
                          _c("field-label", {
                            attrs: { fieldData: _vm.fieldElement["username"] }
                          }),
                          _vm._v(" "),
                          _c("field-tooltip", {
                            attrs: { fieldData: _vm.fieldElement["username"] }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "input-group-text qrp-input-icon-background"
                                },
                                [
                                  _c("icon", {
                                    staticClass: "d-block mx-auto",
                                    attrs: { name: "user", scale: ".6" }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.loginData.email,
                                  expression: "loginData.email",
                                  modifiers: { trim: true }
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "",
                                  expression: "''"
                                }
                              ],
                              ref: "userNameRef",
                              staticClass: "form-control",
                              class: {
                                "form-control": true,
                                error: _vm.errors.has(
                                  _vm.fieldElement["username"].field_name
                                )
                              },
                              attrs: {
                                type: "text",
                                id: _vm.fieldElement["username"].field_name,
                                name: _vm.fieldElement["username"].field_name
                              },
                              domProps: { value: _vm.loginData.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.loginData,
                                    "email",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("field-messages", {
                            attrs: { fieldData: _vm.fieldElement["username"] }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row form-group" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-lg-10 col-xl-7 mx-auto" },
                        [
                          _c("field-label", {
                            attrs: { fieldData: _vm.fieldElement["password"] }
                          }),
                          _vm._v(" "),
                          _c("field-tooltip", {
                            attrs: { fieldData: _vm.fieldElement["password"] }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "input-group-text qrp-input-icon-background"
                                },
                                [
                                  _c("icon", {
                                    staticClass: "d-block mx-auto",
                                    attrs: { name: "lock", scale: ".6" }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.loginData.password,
                                  expression: "loginData.password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "",
                                  expression: "''"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "form-control": true,
                                error: _vm.errors.has(
                                  _vm.fieldElement["password"].field_name
                                )
                              },
                              attrs: {
                                type: "password",
                                id: _vm.fieldElement["password"].field_name,
                                name: _vm.fieldElement["password"].field_name
                              },
                              domProps: { value: _vm.loginData.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.loginData,
                                    "password",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("field-messages", {
                            attrs: { fieldData: _vm.fieldElement["password"] }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mt-1" }, [
                            _c(
                              "div",
                              { staticClass: "col text-right" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "small qrp-text-muted",
                                    attrs: {
                                      to: {
                                        name: "resetPassword",
                                        params: { viewUsage: "reset" }
                                      }
                                    }
                                  },
                                  [_vm._v("Forgot Password?")]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loginError,
                            expression: "loginError"
                          }
                        ],
                        staticClass: "text-center error-red text-notice mb-3"
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(_vm.errorMsg) + "\n      "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "submit" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.submitted($event)
                            }
                          }
                        },
                        [_vm._v("Sign In")]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(1)
              ])
            ]),
            _vm._v(" "),
            _c("main-footer", {
              attrs: { id: "main-footer", role: "contentinfo" }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-10 col-xl-7 mx-auto" }, [
        _c("hr", { attrs: { id: "login-card-hr" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-10 col-xl-7 mx-auto" }, [
        _c("hr", { attrs: { id: "login-card-hr-bottom" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed7c788e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed7c788e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/Login.vue
// module id = null
// module chunks = 